/** Scrolls the anchor to the scrollport top, leaving room for sticky chrome. */
export const scrollAnchorToScrollportTop = (
  anchorEl: HTMLElement,
  stickyTop = 0,
): void => {
  const scrollEl = findScrollableAncestor(anchorEl)
  if (!(scrollEl instanceof HTMLElement)) {
    return
  }

  const top =
    scrollEl.scrollTop +
    anchorEl.getBoundingClientRect().top -
    scrollEl.getBoundingClientRect().top -
    stickyTop
  scrollEl.scrollTo({ top, behavior: 'smooth' })
}

export const findScrollableAncestor = (
  el: Element | null,
): Element | Window | undefined => {
  for (let cur = el?.parentElement; cur; cur = cur.parentElement) {
    const s = window.getComputedStyle(cur)
    const y = s.overflowY === 'auto' || s.overflowY === 'scroll'
    const x = s.overflowX === 'auto' || s.overflowX === 'scroll'
    if (
      (y && cur.scrollHeight > cur.clientHeight) ||
      (x && cur.scrollWidth > cur.clientWidth)
    ) {
      return cur
    }
  }
  const doc = el?.ownerDocument
  const root = doc?.scrollingElement ?? doc?.documentElement
  if (
    root &&
    (root.scrollHeight > root.clientHeight ||
      root.scrollWidth > root.clientWidth)
  ) {
    return doc?.defaultView ?? undefined
  }
  return undefined
}
